import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import Academicleft from "../../IITTP/Academic/Academicleft";
import { Container, Row, Col } from "react-bootstrap";

function Main() {
    const [activeIndex, setActiveIndex] = useState(null);

    const handleToggle = (index) => {
        setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="PG TimeTable" />

            <section className="project-detail">
                <Container>
                    <Row className='my-5'>
                        <Col md={4} className='c-left custom-padding-color mb-4'>

                            <Academicleft activeIndex={10} />
                        </Col>

                        <Col md={8} className='c-right'>


                            <div className="c-heading">
                                <h3>M.Tech/Dual Degree/M.Sc/MPP</h3>
                            </div>

                            <Row>
                                <div
                                    className="col-lg-12 col-md-12  wow fadeInUp animated"
                                    data-animation="fadeInUp"
                                    data-delay=".4s"
                                >
                                    <div
                                        className="faq-wrap pl-30 wow fadeInUp animated"
                                        data-animation="fadeInUp"
                                        data-delay=".4s"
                                    >
                                        <div
                                            className="accordion"
                                            id="accordionExample"
                                        >
                                            {/* Index1 ----------------------  */}
                                             <div className="card">
                                                <div className="card-header">
                                                    <h2 className="mb-0">
                                                        <button
                                                            className={`faq-btn collapsed`}
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#collapse23`}
                                                            onClick={() =>
                                                                handleToggle(1)
                                                            }
                                                        >
                                                            <h4>
                                                            July - December 2026
                                                            </h4>
                                                        </button>
                                                    </h2>
                                                </div>
                                                <div
                                                    id={`collapse23`}
                                                    className={`collapse`}
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="card-body">
                                                        <h4>Slot Systems</h4>
                                                        <ul className="myulcustarrow">
                                                            <li>
                                                                <Link className="c-link"
                                                                    to="https://files.iittp.ac.in/2026/academic/timetable/TimeTable_02SEP2026.pdf"
                                                                    target="_blank"
                                                                >
                                                                    Timetable (July - December 2026 Semester)
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                             {/* Index1 ----------------------  */}
                                            {/* Index1 ----------------------  */}
                                             <div className="card">
                                                <div className="card-header">
                                                    <h2 className="mb-0">
                                                        <button
                                                            className={`faq-btn collapsed`}
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#collapse22`}
                                                            onClick={() =>
                                                                handleToggle(1)
                                                            }
                                                        >
                                                            <h4>
                                                            January - June 2026                                                            </h4>
                                                        </button>
                                                    </h2>
                                                </div>
                                                <div
                                                    id={`collapse22`}
                                                    className={`collapse`}
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="card-body">
                                                        <h4>Slot Systems</h4>
                                                        <ul className="myulcustarrow">
                                                            <li>
                                                                <Link className="c-link"
                                                                    to="https://files.iittp.ac.in/pdfs/timetables/Jan2026/TimeTable_Jan_June_28_01_2026.pdf"
                                                                    target="_blank"
                                                                >
                                                                    Timetable (January - June 2026 Semester)
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                             {/* Index1 ----------------------  */}
                                             <div className="card">
                                                <div className="card-header">
                                                    <h2 className="mb-0">
                                                        <button
                                                            className={`faq-btn collapsed`}
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#collapse21`}
                                                            onClick={() =>
                                                                handleToggle(1)
                                                            }
                                                        >
                                                            <h4>
                                                            July - December 2025
                                                            </h4>
                                                        </button>
                                                    </h2>
                                                </div>
                                                <div
                                                    id={`collapse21`}
                                                    className={`collapse`}
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="card-body">
                                                        <h4>Slot Systems</h4>
                                                        <ul className="myulcustarrow">
                                                            <li>
                                                                <Link className="c-link"
                                                                    to="https://files.iittp.ac.in/pdfs/timetables/Jul2025/Revised_TimeTable_Jul_Dec_01_09_2025.pdf"
                                                                    target="_blank"
                                                                >
                                                                    Timetable (July - December 2025 Semester)
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                             {/* Index1 ----------------------  */}
                                             <div className="card">
                                                <div className="card-header">
                                                    <h2 className="mb-0">
                                                        <button
                                                            className={`faq-btn collapsed`}
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#collapse20`}
                                                            onClick={() =>
                                                                handleToggle(1)
                                                            }
                                                        >
                                                            <h4>
                                                                January - June 2025
                                                            </h4>
                                                        </button>
                                                    </h2>
                                                </div>
                                                <div
                                                    id={`collapse20`}
                                                    className={`collapse`}
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="card-body">
                                                        <h4>Slot Systems</h4>
                                                        <ul className="myulcustarrow">
                                                            <li>
                                                                <Link className="c-link"
                                                                    to="https://files.iittp.ac.in/pdfs/timetables/Jan2025/Revised_TimeTable_JAN_JUNE_2025_30_1_2025.pdf"
                                                                    target="_blank"
                                                                >
                                                                    Timetable (January - June 2025 Semester)
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                             {/* Index1 ----------------------  */}
                                             <div className="card">
                                                <div className="card-header">
                                                    <h2 className="mb-0">
                                                        <button
                                                            className={`faq-btn collapsed`}
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#collapse0`}
                                                            onClick={() =>
                                                                handleToggle(0)
                                                            }
                                                        >
                                                            <h4>
                                                                July - December 2024
                                                            </h4>
                                                        </button>
                                                    </h2>
                                                </div>
                                                <div
                                                    id={`collapse0`}
                                                    className={`collapse`}
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="card-body">
                                                        <h4>Slot Systems</h4>
                                                        <ul className="myulcustarrow">
                                                            <li>
                                                                <Link className="c-link"
                                                                    to="https://files.iittp.ac.in/pdfs/timetables/july2024/July-Dec_2024_TT-06.08.2024.pdf"
                                                                    target="_blank"
                                                                >
                                                                    Timetable (July - December 2024 Semester)
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>


                                            {/* Index 2 ----------------------  */}
                                            {/* Index1 ----------------------  */}
                                            <div className="card">
                                                <div className="card-header">
                                                    <h2 className="mb-0">
                                                        <button
                                                            className={`faq-btn collapsed`}
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#collapse0`}
                                                            onClick={() =>
                                                                handleToggle(1)
                                                            }
                                                        >
                                                            <h4>
                                                                January - June 2024
                                                            </h4>
                                                        </button>
                                                    </h2>
                                                </div>
                                                <div
                                                    id={`collapse0`}
                                                    className={`collapse`}
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="card-body">
                                                        <h4>Slot Systems</h4>
                                                        <ul className="myulcustarrow">
                                                            <li>
                                                                <Link className="c-link"
                                                                    to="https://files.iittp.ac.in/pdfs/timetables/Jan2024/JAN-JUN%202024%20Time-Table_19_1_24.pdf"
                                                                    target="_blank"
                                                                >
                                                                    Timetable (January - June 2024 Semester)
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>


                                            {/* Index 2 ----------------------  */}
                                            <div className="card">
                                                <div className="card-header">
                                                    <h2 className="mb-0">
                                                        <button
                                                            className={`faq-btn collapsed`}
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#collapse1`}
                                                            onClick={() =>
                                                                handleToggle(1)
                                                            }
                                                        >
                                                            <h4>July - December 2023</h4>
                                                        </button>
                                                    </h2>
                                                </div>
                                                <div
                                                    id={`collapse1`}
                                                    className={`collapse`}
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="card-body">
                                                        <h4>Slot Systems</h4>
                                                        <ul className="myulcustarrow">
                                                            <li>
                                                                <Link className="c-link"
                                                                    to="https://files.iittp.ac.in/pdfs/timetables/july2023/B.Tech_1st-year_Except-1st-sem_updated-030823.pdf"
                                                                    target="_blank"
                                                                >
                                                                    Timetable (July-December 2023 Semester)
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>


                                            {/* Index 3 ----------------------  */}
                                            <div className="card">
                                                <div className="card-header">
                                                    <h2 className="mb-0">
                                                        <button
                                                            className={`faq-btn collapsed`}
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#collapse2`}
                                                            onClick={() =>
                                                                handleToggle(1)
                                                            }
                                                        >
                                                            <h4>January - June 2023</h4>
                                                        </button>
                                                    </h2>
                                                </div>
                                                <div
                                                    id={`collapse2`}
                                                    className={`collapse`}
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="card-body">
                                                        <h4>Slot Systems</h4>
                                                        <ul className="myulcustarrow">
                                                            <li>
                                                                <Link className="c-link"
                                                                    to="https://files.iittp.ac.in/pdfs/timetables/Jan2023/Jan-June_2023-TT-03-Feb-2023.pdf"
                                                                    target="_blank"
                                                                >
                                                                    Timetable (January - June 2023 Semester)
                                                                </Link>
                                                            </li>


                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>


                                            {/* Index 4 ----------------------  */}
                                            <div className="card">
                                                <div className="card-header">
                                                    <h2 className="mb-0">
                                                        <button
                                                            className={`faq-btn collapsed`}
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#collapse3`}
                                                            onClick={() =>
                                                                handleToggle(1)
                                                            }
                                                        >
                                                            <h4>July - December 2022</h4>
                                                        </button>
                                                    </h2>
                                                </div>
                                                <div
                                                    id={`collapse3`}
                                                    className={`collapse`}
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="card-body">
                                                        <h4>Slot Systems</h4>
                                                        <ul className="myulcustarrow">
                                                            <li>
                                                                <Link className="c-link"
                                                                    to="https://files.iittp.ac.in/pdfs/timetables/july2022/Slot%20Systems.pdf"
                                                                    target="_blank"
                                                                >
                                                                    Timetable (July - Dec 2022 Semester)
                                                                </Link>
                                                            </li>
                                                        </ul>

                                                        <h4 className="mt-3 mb-3">M.Tech First Year </h4>
                                                        <ul className="myulcustarrow">
                                                            <li className="mt-3 mb-3"><Link className="c-link" to="#" target="_self">Civil and Environmental Engineering</Link></li>

                                                            <ul className="myulcustarrow">
                                                                <li ><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/july2022/M.Tech EWRE Semester-1.pdf" target="_blank">Environmental and Water Resources Engineering</Link></li>
                                                                <li ><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/july2022/M.Tech SE Semester-1.pdf" target="_blank">Structural Engineering</Link></li>
                                                                <li ><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/july2022/M.Tech TIE Semester-1.pdf" target="_blank">Transportation and Infrastructure Engineering</Link></li>
                                                                <li ><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/july2022/M.Tech GTE Semester-1.pdf" target="_blank">Geotechnical Engineering</Link></li>
                                                            </ul>
                                                            <li ><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/july2022/M.Tech CSE Semester-1.pdf" target="_blank">Computer Science Engineering</Link></li>
                                                            <li><Link className="c-link" to="#" target="_self">Electrical Engineering</Link></li>
                                                            <ul className="myulcustarrow">
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/july2022/M.Tech M&amp;VLSI Semester-1.pdf" target="_blank">Microelectronics and VLSI</Link></li>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/july2022/M.Tech SPC Semester-1.pdf" target="_blank">Signal Processing and Communications</Link></li>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/july2022/M.Tech RF&amp;MWE Semester-1.pdf" target="_blank">RF and Microwave Engineering</Link></li>
                                                            </ul>
                                                            <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/july2022/M.Tech D&amp;M Semester-1.pdf" target="_blank">Mechanical Engineering</Link></li>
                                                        </ul>
                                                        <h4 className="mt-3 mb-3">M.Tech Second Year  </h4>

                                                        <ul className="myulcustarrow">

                                                            <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/july2022/M.Tech CSE Semester-3.pdf" target="_blank">Computer Science Engineering</Link></li>
                                                            <li><Link className="c-link" to="#" target="_self">Electrical Engineering</Link></li>
                                                            <ul >
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/july2022/M.Tech M&amp;VLSI Semester-3.pdf" target="_blank">Microelectronics and VLSI</Link></li>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/july2022/M.Tech SPC Semester-3.pdf" target="_blank">Signal Processing and Communications</Link></li>
                                                            </ul>
                                                        </ul>

                                                        <h4 className="mt-3 mb-3">M.Sc Second Year  </h4>

                                                        <ul className="myulcustarrow">
                                                            <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/july2022/M.Sc CY Semester-3.pdf" target="_blank">Chemistry</Link></li>
                                                            <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/july2022/M.Sc MAS Semester-3.pdf" target="_blank">Mathematics &amp; Statistics</Link></li>
                                                            <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/july2022/M.Sc PH semester-3.pdf" target="_blank">Physics</Link></li>
                                                        </ul>

                                                        <h4 className="mt-3 mb-3">Master of Public Policy (MPP) </h4>

                                                        <ul className="myulcustarrow">
                                                            <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/july2022/MPP Semester-1.pdf" target="_blank">Humanities and Social Sciences</Link></li>
                                                        </ul>

                                                        <h4 className="mt-3 mb-3">Elective </h4>

                                                        <ul className="myulcustarrow">
                                                            <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/july2022/MAS Electives.pdf" target="_blank">Mathematics and Statistics</Link></li>
                                                            <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/july2022/PH Electives.pdf" target="_blank">Physics</Link></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>


                                            {/* Index 5 ----------------------  */}
                                            <div className="card">
                                                <div className="card-header">
                                                    <h2 className="mb-0">
                                                        <button
                                                            className={`faq-btn collapsed`}
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#collapse4`}
                                                            onClick={() =>
                                                                handleToggle(1)
                                                            }
                                                        >
                                                            <h4>January - June 2022</h4>
                                                        </button>
                                                    </h2>
                                                </div>
                                                <div
                                                    id={`collapse4`}
                                                    className={`collapse`}
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="card-body">
                                                        <h4>Slot Systems</h4>
                                                        <ul className="myulcustarrow">
                                                            <li>
                                                                <Link className="c-link"
                                                                    to="https://files.iittp.ac.in/pdfs/timetables/july2022/Slot%20Systems.pdf"
                                                                    target="_blank"
                                                                >
                                                                    Timetable (July - Dec 2022 Semester)
                                                                </Link>
                                                            </li>
                                                        </ul>


                                                        <div className="uk-accordion-content uk-active">

                                                            <h4 className="mt-3 mb-3">
                                                                M.Tech First Year
                                                            </h4>
                                                            <ul className="myulcustarrow">
                                                                <li className="mt-3 mb-3"><Link className="c-link" to="#" target="_self">Civil and Environmental Engineering</Link></li>
                                                                <ul >
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2022/M.Tech_CE&amp;E_EWR_I Yr.pdf" target="_blank">Environmental and Water Resources Engineering</Link></li>
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2022/M.Tech_CE&amp;E_SE_I Yr.pdf" target="_blank">Structural Engineering</Link></li>
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2022/M.Tech_CE&amp;E_TIE_I Yr.pdf" target="_blank">Transportation and Infrastructure Engineering</Link></li>
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2022/M.Tech_CE&amp;E_GE_I Yr.pdf" target="_blank">Geotechnical Engineering</Link></li>
                                                                </ul>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2022/TimeTable_Jan2022_MTech_SemII_CSE.pdf" target="_blank">Computer Science Engineering</Link></li>
                                                                <li><Link className="c-link" to="#" target="_blank">Electrical Engineering</Link></li>
                                                                <ul >
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2022/M.Tech_EE Me&amp; VLSI_I Yr.pdf" target="_blank">Microelectronics and VLSI</Link></li>
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2022/M.Tech_EE_SP&amp;C_I Yr.pdf" target="_blank">Signal Processing and Communications</Link></li>

                                                                </ul>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2022/M.Tech_ME_I Yr.pdf" target="_blank">Mechanical Engineering</Link></li>
                                                            </ul>
                                                            <h4 className="mt-3 mb-3">
                                                                M.Tech Second Year
                                                            </h4>
                                                            <ul className="myulcustarrow">
                                                                <li className="mt-3 mb-3"><Link className="c-link" to="#" target="_self">Civil and Environmental Engineering</Link></li>
                                                                <ul>
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2022/M.Tech_CE&amp;E_EWRE_GTE_SE_TIE_II.pdf" target="_blank">Environmental and Water Resources Engineering</Link></li>
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2022/M.Tech_CE&amp;E_EWRE_GTE_SE_TIE_II.pdf" target="_blank">Geotechnical Engineering</Link></li>
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2022/M.Tech_CE&amp;E_EWRE_GTE_SE_TIE_II.pdf" target="_blank">Structural Engineering</Link></li>
                                                                </ul>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2022/M.Tech_CSE_II Yr.pdf" target="_blank">Computer Science Engineering</Link></li>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2022/M.Tech_EE_SP&amp;C_II Yr.pdf" target="_blank">Electrical Engineering</Link></li>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2022/M.Tech_2ndyear_Timetable_Jan_2022.pdf" target="_blank">Mechanical Engineering</Link></li>
                                                            </ul>

                                                            <h4 className="mt-3 mb-3">
                                                                M.Sc First Year
                                                            </h4>
                                                            <ul className="myulcustarrow">

                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2022/Timetable_Jan_2022_MSc_CY_I Yr.pdf" target="_blank">Chemistry</Link></li>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2022/Timetable Jan 2022_MSc_Maths_I Yr.pdf" target="_blank">Mathematics &amp; Statistics</Link></li>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2022/Timetable Jan 2022_MSc_PH_I Yr.pdf" target="_blank">Physics</Link></li>

                                                            </ul>
                                                            <h4 className="mt-3 mb-3">
                                                                M.Sc Second Year
                                                            </h4>
                                                            <ul className="myulcustarrow">
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2022/Timetable_Jan_2022_MSc_CY_II Yr.pdf" target="_blank">Chemistry</Link></li>

                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2022/Timetable Jan 2022_MSc_Maths_II Yr.pdf" target="_blank">Mathematics &amp; Statistics</Link></li>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2022/PH_IV Semester - II Year M.Sc._Timetable_Jan_2022.pdf" target="_blank">Physics</Link></li>


                                                            </ul>


                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Index 6 ----------------------  */}

                                            <div className="card">
                                                <div className="card-header">
                                                    <h2 className="mb-0">
                                                        <button
                                                            className={`faq-btn collapsed`}
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#collapse5`}
                                                            onClick={() =>
                                                                handleToggle(2)
                                                            }
                                                        >
                                                            <h4>July -December 2021</h4>
                                                        </button>
                                                    </h2>
                                                </div>
                                                <div
                                                    id={`collapse5`}
                                                    className={`collapse`}
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="card-body">
                                                        <div className="uk-accordion-content uk-active">

                                                            <h4 className="mt-3 mb-3">
                                                                M.Tech First Year
                                                            </h4>
                                                            <ul className="myulcustarrow">
                                                                <li className="mt-3 mb-3"><Link className="c-link" to="#" target="_self">Civil and Environmental Engineering</Link></li>
                                                                <ul >
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2021/M.Tech EWRE 1st sem.pdf" target="_blank">Environmental and Water Resources Engineering</Link></li>
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2021/M.Tech SE 1st sem.pdf" target="_blank">Structural Engineering</Link></li>
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2021/M.Tech TIE 1st sem.pdf" target="_blank">Transportation and Infrastructure Engineering</Link></li>
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2021/M.Tech GE 1st sem.pdf" target="_blank">Geotechnical Engineering</Link></li>
                                                                </ul>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2021/M.Tech CSE 1st sem.pdf" target="_blank">Computer Science Engineering</Link></li>
                                                                <li><Link className="c-link" to="#" target="_blank">Electrical Engineering</Link></li>
                                                                <ul >
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2021/M.Tech MVLSI 1st Sem.pdf" target="_blank">Microelectronics and VLSI</Link></li>
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2021/M.Tech SPC 1st sem.pdf" target="_blank">Signal Processing and Communications</Link></li>

                                                                </ul>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2021/Mtech_ME_1st_year.pdf" target="_blank">Mechanical Engineering</Link></li>
                                                            </ul>
                                                            <h4 className="mt-3 mb-3">
                                                                M.Tech Second Year
                                                            </h4>
                                                            <ul className="myulcustarrow">
                                                                <li className="mt-3 mb-3"><Link className="c-link" to="#" target="_self">Civil and Environmental Engineering</Link></li>
                                                                <ul >
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2021/M.Tech EWRE 3rd sem.pdf" target="_blank">Environmental and Water Resources Engineering</Link></li>
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2021/M.Tech GE 3rd sem.pdf" target="_blank">Geotechnical Engineering</Link></li>
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2021/M.Tech SE 3rd sem.pdf" target="_blank">Structural Engineering</Link></li>
                                                                </ul>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2021/M.Tech CSE 3rd sem.pdf" target="_blank">Computer Science Engineering</Link></li>

                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2021/M.Tech DM 3rd sem.pdf" target="_blank">Mechanical Engineering</Link></li>
                                                            </ul>
                                                            <h4 className="mt-3 mb-3">
                                                                Dual Degree
                                                            </h4>
                                                            <ul className="myulcustarrow">

                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2021/DD SPC 7th Sem.pdf" target="_blank">Signal Processing and Communications</Link></li>


                                                            </ul>
                                                            <h4 className="mt-3 mb-3">
                                                                M.Sc First Year
                                                            </h4>
                                                            <ul className="myulcustarrow">

                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2021/M.Sc CY 1st sem.pdf" target="_blank">Chemistry</Link></li>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2021/M.Sc MAS 1st sem.pdf" target="_blank">Mathematics &amp; Statistics</Link></li>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2021/M.Sc PH 1st sem.pdf" target="_blank">Physics</Link></li>

                                                            </ul>
                                                            <h4 className="mt-3 mb-3">
                                                                M.Sc Second Year
                                                            </h4>
                                                            <ul className="myulcustarrow">
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2021/M.Sc CY 3rd sem.pdf" target="_blank">Chemistry</Link></li>

                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2021/M.Sc MAS 3rd sem.pdf" target="_blank">Mathematics &amp; Statistics</Link></li>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2021/M.Sc PH 3rd sem.pdf" target="_blank">Physics</Link></li>


                                                            </ul>


                                                        </div>


                                                    </div>
                                                </div>
                                            </div>



                                            {/* Index  7 ----------------------  */}

                                            <div className="card">
                                                <div className="card-header">
                                                    <h2 className="mb-0">
                                                        <button
                                                            className={`faq-btn collapsed`}
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#collapse6`}
                                                            onClick={() =>
                                                                handleToggle(2)
                                                            }
                                                        >
                                                            <h4>January -June 2021</h4>
                                                        </button>
                                                    </h2>
                                                </div>
                                                <div
                                                    id={`collapse6`}
                                                    className={`collapse`}
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="card-body">

                                                        <div className="uk-accordion-content uk-active">

                                                            <h4 className="mt-3 mb-3">
                                                                M.Tech First Year
                                                            </h4>
                                                            <ul className="myulcustarrow">
                                                                <li className="mt-3 mb-3"><Link className="c-link" to="#" target="_self">Civil and Environmental Engineering</Link></li>
                                                                <ul >
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2021/I Year M.Tech EWRE.pdf" target="_blank">Environmental and Water Resources Engineering</Link></li>
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2021/I Year M.Tech SE.pdf" target="_blank">Structural Engineering</Link></li>
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2021/I Year M.Tech TIE.pdf" target="_blank">Transportation and Infrastructure Engineering</Link></li>
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2021/I Year M.Tech GTE.pdf" target="_blank">Geotechnical Engineering</Link></li>
                                                                </ul>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2021/I Year M.Tech CSE.pdf" target="_blank">Computer Science Engineering</Link></li>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2021/I Year M.Tech EE.pdf" target="_blank">Electrical Engineering</Link></li>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2021/I Year M.Tech ME.pdf" target="_blank">Mechanical Engineering</Link></li>
                                                            </ul>
                                                            <h4 className="mt-3 mb-3">
                                                                M.Tech Second Year
                                                            </h4>
                                                            <ul className="myulcustarrow">

                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2021/II Year M.Tech EE.pdf" target="_blank">Electrical Engineering</Link></li>

                                                            </ul>
                                                            <h4 className="mt-3 mb-3">
                                                                M.Sc First Year
                                                            </h4>
                                                            <ul className="myulcustarrow">

                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2021/I Year M.Sc CY.pdf" target="_blank">Chemistry</Link></li>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2021/I Year M.Sc MAS.pdf" target="_blank">Mathematics &amp; Statistics</Link></li>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2021/I Year M.Sc PH.pdf" target="_blank">Physics</Link></li>

                                                            </ul>
                                                            <h4 className="mt-3 mb-3">
                                                                M.Sc Second Year
                                                            </h4>
                                                            <ul className="myulcustarrow">


                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2021/II Year M.Sc MAS.pdf" target="_blank">Mathematics &amp; Statistics</Link></li>


                                                            </ul>


                                                        </div>

                                                    </div>
                                                </div>
                                            </div>



                                            {/* Index  8 ----------------------  */}

                                            <div className="card">
                                                <div className="card-header">
                                                    <h2 className="mb-0">
                                                        <button
                                                            className={`faq-btn collapsed`}
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#collapse7`}
                                                            onClick={() =>
                                                                handleToggle(2)
                                                            }
                                                        >
                                                            <h4>July -December 2020</h4>
                                                        </button>
                                                    </h2>
                                                </div>
                                                <div
                                                    id={`collapse7`}
                                                    className={`collapse`}
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="card-body">

                                                        <div className="uk-accordion-content uk-active">

                                                            <h4 className="mt-3 mb-3">
                                                                M.Tech First Year
                                                            </h4>
                                                            <ul className="myulcustarrow">
                                                                <li className="mt-3 mb-3"><Link className="c-link" to="#" target="_self">Civil and Environmental Engineering</Link></li>
                                                                <ul >
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2020/M.Tech 1st Year EWRE.pdf" target="_blank">Environmental and Water Resources Engineering</Link></li>
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2020/M.Tech 1st Year SE.pdf" target="_blank">Structural Engineering</Link></li>
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2020/M.Tech 1st Year TIE.pdf" target="_blank">Transportation and Infrastructure Engineering</Link></li>
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2020/M.Tech 1st Year GT.pdf" target="_blank">Geotechnical Engineering</Link></li>
                                                                </ul>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2020/M.Tech 1st Year CSE.pdf" target="_blank">Computer Science Engineering</Link></li>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2020/M.Tech 1st Year SPC.pdf" target="_blank">Electrical Engineering</Link></li>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2020/M.Tech 1st Year DM.pdf" target="_blank">Mechanical Engineering</Link></li>
                                                            </ul>
                                                            <h4 className="mt-3 mb-3">
                                                                M.Tech Second Year
                                                            </h4>
                                                            <ul className="myulcustarrow">

                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2020/M.Tech 2nd Year SPC.pdf" target="_blank">Electircal Engineering</Link></li>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2020/M.Tech 2nd Year DM.pdf" target="_blank">Mechanical Engineering</Link></li>
                                                            </ul>
                                                            <h4 className="mt-3 mb-3">
                                                                M.Sc First Year
                                                            </h4>
                                                            <ul className="myulcustarrow">

                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2020/M.Sc 1st Year CY.pdf" target="_blank">Chemistry</Link></li>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2020/M.Sc 1st Year MAS.pdf" target="_blank">Mathematics &amp; Statistics</Link></li>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2020/M.Sc 1st Year PH.pdf" target="_blank">Physics</Link></li>

                                                            </ul>
                                                            <h4 className="mt-3 mb-3">
                                                                M.Sc Second Year
                                                            </h4>
                                                            <ul className="myulcustarrow">


                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jul2020/M.Sc 2nd Year MAS.pdf" target="_blank">Mathematics &amp; Statistics</Link></li>


                                                            </ul>


                                                        </div>

                                                    </div>
                                                </div>
                                            </div>


                                            {/* Index  9 ----------------------  */}

                                            <div className="card">
                                                <div className="card-header">
                                                    <h2 className="mb-0">
                                                        <button
                                                            className={`faq-btn collapsed`}
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#collapse8`}
                                                            onClick={() =>
                                                                handleToggle(2)
                                                            }
                                                        >
                                                            <h4>January -June 2020</h4>
                                                        </button>
                                                    </h2>
                                                </div>
                                                <div
                                                    id={`collapse8`}
                                                    className={`collapse`}
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="card-body">

                                                        <ul className="myulcustarrow">
                                                            <li className="mt-3 mb-3"><Link className="c-link" to="#" target="_self">Civil and Environmental Engineering</Link></li>
                                                            <ul>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2020/I Year M.Tech EWRE.pdf" target="_blank">Environmental and Water Resources Engineering</Link></li>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2020/I Year M.Tech SE.pdf" target="_blank">Structural Engineering</Link></li>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2020/I Year M.Tech TIE.pdf" target="_blank">Transportation and Infrastructure Engineering</Link></li>

                                                            </ul>
                                                            <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2020/I Year M.Tech CS.pdf" target="_blank">Computer Science Engineering</Link></li>
                                                            <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2020/I Year M.Tech EE.pdf" target="_blank">Electrical Engineering</Link></li>
                                                            <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2020/I Year MSc.pdf" target="_blank">Mathematics &amp; Statistics</Link></li>
                                                            <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/jan2020/I Year M.Tech ME.pdf" target="_blank">Mechanical Engineering</Link></li>
                                                        </ul>

                                                    </div>
                                                </div>
                                            </div>



                                            {/* Index  10 ----------------------  */}

                                            <div className="card">
                                                <div className="card-header">
                                                    <h2 className="mb-0">
                                                        <button
                                                            className={`faq-btn collapsed`}
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#collapse9`}
                                                            onClick={() =>
                                                                handleToggle(2)
                                                            }
                                                        >
                                                            <h4>July - December 2019</h4>
                                                        </button>
                                                    </h2>
                                                </div>
                                                <div
                                                    id={`collapse9`}
                                                    className={`collapse`}
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="card-body">

                                                        <div className="uk-accordion-content uk-active">

                                                            <h5>
                                                                First Year
                                                            </h5>

                                                            <ul className="myulcustarrow">
                                                                <li className="mt-3 mb-3"><Link className="c-link" to="#" target="_self">Civil and Environmental Engineering</Link></li>
                                                                <ul >
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/M.TechEWRE.pdf" target="_blank">Environmental and Water Resources Engineering</Link></li>
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/M.TechSE.pdf" target="_blank">Structural Engineering</Link></li>
                                                                    <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/M.TechTIE.pdf" target="_blank">Transportation and Infrastructure Engineering</Link></li>

                                                                </ul>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/M.TechCSEJul2019.pdf" target="_blank">Computer Science Engineering</Link></li>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/M.TechEEJul2019.pdf" target="_blank">Electrical Engineering</Link></li>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/M.ScMASta.pdf" target="_blank">Mathematics &amp; Statistics</Link></li>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/M.TechMEJu2019.pdf" target="_blank">Mechanical Engineering</Link></li>
                                                            </ul>

                                                            <h5>
                                                                Second Year
                                                            </h5>

                                                            <ul className="myulcustarrow">

                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/M.TechCSESYJul2019.pdf" target="_blank">Computer Science Engineering</Link></li>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/M.TechEESYJul2019.pdf" target="_blank">Electrical Engineering</Link></li>
                                                                <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/M.TechMESYJul2019.pdf" target="_blank">Mechanical Engineering</Link></li>
                                                            </ul>

                                                        </div>

                                                    </div>
                                                </div>
                                            </div>




                                            {/* Section 2-----------------------------------------------------------------------------------------*/}

                                            {/* Index1 ----------------------- start*/}

                                            <div className="c-heading">
                                                <h3>M.S (Research)/Ph.D</h3>
                                            </div>

                                            <div className="card">
                                                <div className="card-header">
                                                    <h2 className="mb-0">
                                                        <button
                                                            className={`faq-btn collapsed`}
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#collapseSec0`}
                                                            onClick={() =>
                                                                handleToggle(2)
                                                            }
                                                        >
                                                            <h4>January - June 2022</h4>
                                                        </button>
                                                    </h2>
                                                </div>
                                                <div
                                                    id={`collapseSec0`}
                                                    className={`collapse`}
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="card-body">
                                                        <ul className="myulcustarrow">
                                                            <li>
                                                                <Link className="c-link"
                                                                    to="https://files.iittp.ac.in/pdfs/timetables/jan2022/Ph.D__EE_RF and Microwave Engineering.pdf"
                                                                    target="_blank"
                                                                >
                                                                    Electrical
                                                                    Engineering
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link className="c-link"
                                                                    to="https://files.iittp.ac.in/pdfs/timetables/jan2022/PhD Time Table HSS.pdf"
                                                                    target="_blank"
                                                                >
                                                                    Humanities & Social
                                                                    Sciences
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link className="c-link"
                                                                    to="https://files.iittp.ac.in/pdfs/timetables/jan2022/Timetable Jan 2022_PhD_PH.pdf"
                                                                    target="_blank"
                                                                >
                                                                    Physics
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>



                                            {/* Index2 ----------------------- start*/}
                                            <div className="card">
                                                <div className="card-header">
                                                    <h2 className="mb-0">
                                                        <button
                                                            className={`faq-btn collapsed`}
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#collapseSec1`}
                                                            onClick={() =>
                                                                handleToggle(3)
                                                            }
                                                        >
                                                            <h4>January - June 2021</h4>
                                                        </button>
                                                    </h2>
                                                </div>
                                                <div
                                                    id={`collapseSec1`}
                                                    className={`collapse`}
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="card-body">
                                                        <ul className="myulcustarrow">
                                                            <li>
                                                                <Link className="c-link"
                                                                    to="https://files.iittp.ac.in/pdfs/timetables/jan2021/Time table_Chemical Engineering.pdf"
                                                                    target="_blank"
                                                                >
                                                                    Chemical Engineering
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link className="c-link"
                                                                    to="https://files.iittp.ac.in/pdfs/timetables/jan2021/Time table_Physics.pdf"
                                                                    target="_blank"
                                                                >
                                                                    Physics
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>


                                            {/*Index3---------------*/}
                                            <div className="card">
                                                <div className="card-header">
                                                    <h2 className="mb-0">
                                                        <button
                                                            className={`faq-btn collapsed`}
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#collapseSec2`}
                                                            onClick={() =>
                                                                handleToggle(4)
                                                            }
                                                        >
                                                            <h4>January - June 2020</h4>
                                                        </button>
                                                    </h2>
                                                </div>
                                                <div
                                                    id={`collapseSec2`}
                                                    className={`collapse`}
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="card-body">
                                                        <ul className="myulcustarrow">
                                                            <li>
                                                                <Link className="c-link"
                                                                    to="https://files.iittp.ac.in/pdfs/timetables/jan2020/MSPhD-2020.pdf"
                                                                    target="_blank"
                                                                >
                                                                    M.S/Ph.D
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>


                                            {/*Index4---------------*/}
                                            <div className="card">
                                                <div className="card-header">
                                                    <h2 className="mb-0">
                                                        <button
                                                            className={`faq-btn collapsed`}
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#collapseSec3`}
                                                            onClick={() =>
                                                                handleToggle(4)
                                                            }
                                                        >
                                                            <h4>July - December 2019</h4>
                                                        </button>
                                                    </h2>
                                                </div>
                                                <div
                                                    id={`collapseSec3`}
                                                    className={`collapse`}
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="card-body">
                                                        <ul className="myulcustarrow">

                                                            <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/ME_MS-PhD.pdf" target="_blank">Mechanical Engineering</Link></li>

                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>


                                            {/*Index5---------------*/}
                                            <div className="card">
                                                <div className="card-header">
                                                    <h2 className="mb-0">
                                                        <button
                                                            className={`faq-btn collapsed`}
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#collapseSec4`}
                                                            onClick={() =>
                                                                handleToggle(4)
                                                            }
                                                        >
                                                            <h4>January - June 2019</h4>
                                                        </button>
                                                    </h2>
                                                </div>
                                                <div
                                                    id={`collapseSec4`}
                                                    className={`collapse`}
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="card-body">
                                                        <ul className="myulcustarrow">

                                                            <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/Jan2019-MSPHD-Civil.pdf" target="_blank">Civil Engineering</Link></li>
                                                            <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/Jan2019-MtechY1-CSE.pdf" target="_blank">Computer Science Engineering</Link></li>
                                                            <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/Jan2019-MtechY1-EE.pdf" target="_blank">Electrical Engineering</Link></li>
                                                            <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/Jan2019-MtechY1-ME.pdf" target="_blank">Mechanical Engineering</Link></li>

                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>



                                            {/*Index6---------------*/}
                                            <div className="card">
                                                <div className="card-header">
                                                    <h2 className="mb-0">
                                                        <button
                                                            className={`faq-btn collapsed`}
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#collapseSec5`}
                                                            onClick={() =>
                                                                handleToggle(4)
                                                            }
                                                        >
                                                            <h4>January - June 2019</h4>
                                                        </button>
                                                    </h2>
                                                </div>
                                                <div
                                                    id={`collapseSec5`}
                                                    className={`collapse`}
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="card-body">
                                                        <ul className="myulcustarrow">

                                                            <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/Mtech-Jul2018-CSE.pdf" target="_blank">Computer Science Engineering</Link></li>
                                                            <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/Mtech-Jul2018-EE.pdf" target="_blank">Electrical Engineering</Link></li>
                                                            <li><Link className="c-link" to="https://files.iittp.ac.in/pdfs/timetables/Mtech-Jul2018-ME.pdf" target="_blank">Mechanical Engineering</Link></li>

                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
}

export default Main;
